//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/**
 * Accepts an array of objects and merges them together into a single object of the same array element type.
 * Note that conflicting fields for multiple elements will be merged, preferring those elements with larger indices
 *
 * @param arr An array of arrays of U.
 */
export function mergeObjects<U extends object>(arr: ReadonlyArray<U>): U {
  return Object.assign({}, ...arr);
}
